// extracted by mini-css-extract-plugin
export default {"backButton":"BatchRunBreadCrumb_backButton__HLRbg","label":"BatchRunBreadCrumb_label__bLRs4","text":"BatchRunBreadCrumb_text__Ve8Kq"};